// ClientDetails.jsx

// Dependencies
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import ProfileSection from '@/components/data/common/profile/ProfileSection';
import ClientAlias from '@/components/data/clients/ClientAlias';
import ClientEngagements from '@/components/data/clients/ClientEngagements';

const ClientDetails = ({ client, engagements }) => {
  const { t } = useTranslation();

  const title = t('CLIENTS_TABLE.TITLE');
  const fields = [
    t('CLIENTS_TABLE.HEADERS.CLIENT_CODE'),
    t('CLIENTS_TABLE.HEADERS.CLIENT'),
    t('CLIENTS_TABLE.HEADERS.ALIAS')
  ];
  const data = [
    client.ClientCode,
    client.Client,
    <ClientAlias clientCode={client.ClientCode} clientAlias={client.Alias} />
  ];

  return (
    <div>
      <ProfileSection title={title} fields={fields} data={data} />
      {engagements && engagements.length > 0 && (
        <ClientEngagements engagements={engagements} />
      )}
    </div>
  );
};

export default ClientDetails;
